// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","887":"Detail"}[chunkId] + "." + {"443":"8061b74e","887":"a15fc78e"}[chunkId] + ".css";
};